// Réplica de es.cinfo.tiivii.admin.model.mappers.utils.LarixUrlBuilder (frontend-web-backend),
// necesaria porque el REST de eventos no precalcula esta URL como sí hace el resolver GraphQL.
const LARIX_PARAM = "#rtmpUrl";

const LARIX_VIDEO_URL_TEMPLATE =
  "larix://set/v1?conn[][url]=#rtmpUrl&conn[][name]=send%20stream%20to%20tiivii.com&conn[][mode]=av&enc[vid][res]=1280x720&enc[vid][format]=avc&enc[vid][fps]=30&enc[vid][bitrate]=2000&enc[vid][keyframe]=2&enc[aud][bitrate]=128&enc[aud][samples]=48000&enc[aud][channels]=2";

const LARIX_AUDIO_URL_TEMPLATE =
  "larix://set/v1?conn[][url]=#rtmpUrl&conn[][name]=send%20stream%20to%20tiivii.com&conn[][mode]=av&enc[vid][res]=176x144&enc[vid][format]=avc&enc[vid][fps]=30&enc[vid][bitrate]=200&enc[vid][keyframe]=2&enc[aud][bitrate]=128&enc[aud][samples]=48000&enc[aud][channels]=2";

export const buildLarixUrl = (type, url) => {
  if (!url) {
    return null;
  }
  const template =
    type === "VIDEO+AUDIO" ? LARIX_VIDEO_URL_TEMPLATE : type === "AUDIO-ONLY" ? LARIX_AUDIO_URL_TEMPLATE : null;
  if (!template) {
    return null;
  }
  return template.replace(LARIX_PARAM, encodeURIComponent(url));
};
